<template>
  <div class="container-list container">
    <div class="contain flex">
      <div class="company_page" style="border: 1px solid #ccc; height: 100%">
        <!-- <el-input>a</el-input> -->
        <div class="mt10 center">
          <el-input placeholder="请输入名称查询" clearable prefix-icon="el-icon-search" v-model="searcomp"> </el-input>
        </div>
        <div class="mt10 flex center">
          <v-select :value.sync="c_belong_profession" :id="66" place-holder="请选择所属行业"></v-select>
          <el-button class="ml20" size="small" type="primary" @click="clear">
            重置
          </el-button>
        </div>

        <div class="comp_body mt10">
          <el-table :data="list" @cell-dblclick="linto" @cell-click="mymove" v-if="!searcomp && !c_belong_profession">
            <el-table-column prop="c_name" label="单位名称" align="center"> </el-table-column>
          </el-table>
          <el-table :data="searchList" @cell-click="mymove" @cell-dblclick="linto" v-if="searcomp || c_belong_profession">
            <el-table-column prop="c_name" label="单位名称" align="center"> </el-table-column>
          </el-table>
        </div>
        <!-- <el-pagination
          background
          layout="prev, pager, next"
          :page-size="params.limit || 10"
          :pager-count="4||''"
          @current-change="pageChange"
          :total="total"
        >
        </el-pagination> -->
      </div>

      <div class="flex1 ml10">
        <mapInfo :marker="markers" :c_num="c_num"></mapInfo>
      </div>
      <el-dialog title="单位详情" style="min-height: 500px; overflow: auto" :visible.sync="showmod" width="90%" :close-on-click-modal="false">
        <company :c_num="c_num" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import unitList from "@/components/unitList";
import company from "./companyinfo.vue";
import mapInfo from "./jiejingMap.vue";
export default {
  components: {
    unitList,
    company,
    mapInfo,
  },
  data() {
    return {
      //   nowIndex: this.$route.query.index || 0,
      position: [120.36173, 36.082949],
      zoom: 13,
      searcomp: "", // 名称查询项
      c_belong_profession: "", //所属行业
      showmod: false,
      showmodall: false,
      params: { page: 1 },
      markers: [],
      total: 0,
      list: [],
      searchList: [],
      c_num: "",
    };
  },
  created() {
    // this.getOne();
    this.getList();
  },
  watch: {
    searcomp(val) {
      if (val) {
        var arr = [];
        this.list.map((item, index) => {
          if (item.c_name.indexOf(val) !== -1) {
            arr.push(item);
          }
          this.searchList = arr;
        });
      }
    },
    c_belong_profession(val) {
      var arr = [];
      this.list.map((item, index) => {
        if (item.c_belong_profession === val) {
          arr.push(item);
        }
      });
      this.searchList = arr;
    },
  },
  mounted() {},
  methods: {
    linto(it) {
      this.$router.push({
        path: "/jiejing/jiejingdetail",
        query: { id: it.c_company_num },
      });
    },
    clear() {
      this.c_belong_profession = "";
      this.searcomp = "";
    },
    getList() {
      this.$post("/user/areabase", this.params).then((res) => {
        this.total = res.count;
        this.list = res.list;
        this.$store.commit("SAVECOMP", res.list);

        var arr = [];
        res.list.map((item, index) => {
          var obj = {};
          obj.position = [Number(item.lon), Number(item.lat)];

          (obj.showmod = false),
            (obj.text = `<div> <span style='font-size:12px'>${item.c_name}</span></div>
                                   
                                               `);
          obj.c_company_num = item.c_company_num;
          (obj.loca = {
            click: (e) => {
              this.showmod = true;
              this.c_num = item.c_company_num;
            },
            mouseover: () => {
              this.markers[index].showmod = true;
            },
            mouseout: () => {
              this.markers[index].showmod = false;
            },
          }),
            arr.push(obj);
        });
        this.markers = arr;
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    getOne(val) {
      this.cpNum = val;
    },
    mymove(it) {
      this.c_num = it.c_company_num;
    },
    getUnit(val) {
      this.cpNum = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.contain {
  height: 100%;
}
.company_page {
  width: 20%;
  height: 50%;
}
.comp_body {
  padding: 0;
  overflow: auto;
  height: 80%;
}
.container {
  height: 38vw;
}
</style>
